// Installs globalThis.Temporal only on engines that lack it natively.
import 'temporal-polyfill/global';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App.tsx';
import '@insio/ui-toolkit/styles.css';
import './index.css';
import posthog from 'posthog-js';
import { getConfig } from './config.ts';
import { installPreloadErrorReload } from '@insio/ui-toolkit';
import { ANALYTICS_PRIVACY_CONFIG } from './services/analytics-redaction.ts';

installPreloadErrorReload();

const { posthogToken, posthogHost } = getConfig();

if (posthogToken && posthogHost) {
  posthog.init(posthogToken, {
    api_host: posthogHost,
    defaults: '2026-01-30',
    autocapture: false,
    capture_pageview: true,
    capture_exceptions: true,
    capture_heatmaps: true,
    capture_dead_clicks: true,
    // Dead clicks carry the clicked element's text and attributes — keep both masked,
    // the app renders invoice and supplier data.
    mask_all_text: true,
    mask_all_element_attributes: true,
    // Link tokens (`/unsubscribe?token=…` and the auth callbacks) never leave in a URL.
    ...ANALYTICS_PRIVACY_CONFIG
  });
} else if (import.meta.env.DEV) {
  // eslint-disable-next-line no-console
  console.warn(
    'VITE_PUBLIC_POSTHOG_PROJECT_TOKEN and/or VITE_PUBLIC_POSTHOG_HOST variables required by PostHog are missing or unconfigured; events will be silently dropped. This warning disappears once both are configured.'
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
